import React, { useState } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import { Tvariant, Message } from "./Messages";

export const UIMessageContext = React.createContext<{
  showMessage: (message: string, variant: Tvariant) => void;
}>({
  showMessage: () => {}
});

type GlobleMessageProps = {
  message: string;
  open: boolean;
  onClose: () => void;
  variant: Tvariant;
};

const GlobleMessage: React.FunctionComponent<GlobleMessageProps> = ({
  message,
  open,
  onClose,
  variant
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={(event, reason) => {
        if (reason === "timeout") {
          onClose();
        }
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <Message message={message} onClose={onClose} variant={variant} />
    </Snackbar>
  );
};

type UIMessageProviderProps = {
  children: React.ReactNode;
};

type UIMessageState = {
  open: boolean;
  message: string;
  variant: Tvariant;
};

export const UIMessageProvider = (props: UIMessageProviderProps) => {
  const [state, setState] = useState<UIMessageState>({
    open: false,
    message: "",
    variant: "success"
  });

  const showMessage = (message: string, variant: Tvariant): void => {
    setState({
      open: true,
      message,
      variant: variant
    });
  };

  return (
    <UIMessageContext.Provider value={{ showMessage }}>
      {props.children}
      <GlobleMessage
        open={state.open}
        variant={state.variant}
        message={state.message}
        onClose={() => {
          setState({
            ...state,
            open: false
          });
        }}
      />
    </UIMessageContext.Provider>
  );
};
